// © Microsoft Corporation. All rights reserved.

import { InspectorArgs, InspectorResponse, appEnvironment } from "@msnews/core";
import { SocialConfig, SocialState } from "./index";

import { SocialProps } from "./Social.props";

export const SocialInspector = {
    inspect: (args: InspectorArgs<SocialConfig, SocialState, any>): InspectorResponse<SocialProps> => {

        const { config, state } = args;
        let { moduleName, market, theme, commentDisplayType, styleOverrides } = config;
        const { id } = state;
        if (state.moduleName) {
            moduleName = state.moduleName;
        }

        if (state.theme) {
            theme = state.theme;
        }

        if (state.commentDisplayType) {
            commentDisplayType = state.commentDisplayType;
        }

        if (state.market) {
            market = state.market;
        }

        if (!theme) {
            theme = "default";
        }

        if (!market) {
            market = appEnvironment ? appEnvironment.CurrentMarket : "en-us";
        }

        if (!commentDisplayType) {
            commentDisplayType = "default";
        }

        const props = { ...args.state, id, moduleName, market, t: config.localizedStrings, theme, commentDisplayType, jssStyleSheet: styleOverrides };
        return { props, missingChildren: [] };
    }
};